import NavBarContent from "@/domain/entities/navbar/NavBarContent";
import navBarContentMapper from "@/mappers/navbar/navBarContentMapper";
import { useNavBarContent } from "@cs_teamwaydev/mailvista-sdk_react";
import { useMemo } from "react";
import useLiveErrorNotifier from "./utils/useLiveErrorNotifier";

const useGetNavbarData = (): {
    navbarData: NavBarContent | undefined;
    unProcessedFocusMailCount: number | undefined;
    isLoading: boolean;
} => {
    const { data, isLoading, error } = useNavBarContent();

    useLiveErrorNotifier(error, { titleTranslationKey: "errors.navbar" });

    const navbarData = useMemo(
        () => (data ? navBarContentMapper(data) : undefined),
        [data],
    );

    return {
        navbarData,
        isLoading,
        unProcessedFocusMailCount: navbarData?.unProcessedFocusMailCount || 0,
    };
};

export default useGetNavbarData;
